// Pass predicates shared across stepped tools.
import type { SubRating, EvalTone, EvalCheck } from "@/lib/types";

const PASS_RATINGS: SubRating[] = ["Excellent", "Strong"];

// Item-level pass: Strong or Excellent.
export const isPass = (rating: SubRating): boolean => PASS_RATINGS.includes(rating);

// Paragraph-level (tone) pass: anything that isn't "needs-work".
export const tonePass = (tone: EvalTone): boolean => tone !== "needs-work";

// Low-to-high ordering of the sub-ratings, for weakest-link gating.
const RATING_RANK: Record<SubRating, number> = {
  "Needs work": 0,
  Emerging: 1,
  Developing: 2,
  Strong: 3,
  Excellent: 4,
};

// Weakest-link gate for multi-dimension feedback (e.g. Figurative Language's
// Fresh + Fits): a figure passes only when EVERY graded dimension clears the
// bar, so the gate reads the LOWEST rating across the checks. Empty checks
// default to "Strong" to preserve the runner's pre-eval fallback.
export const weakestRating = (checks: EvalCheck[]): SubRating => {
  if (checks.length === 0) return "Strong";
  return checks.reduce<SubRating>(
    (lowest, c) => (RATING_RANK[c.rating] < RATING_RANK[lowest] ? c.rating : lowest),
    "Excellent",
  );
};
